var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwift(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_305_766)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.655 2.5C42.24 14.235 36.5375 27.13 36.5375 27.13C36.5375 27.13 41.5325 32.6575 39.525 37.5C39.525 37.5 37.4525 34.1175 34.0125 34.1175C30.6875 34.1175 28.72 37.5 22.0075 37.5C7.0775 37.5 0 25.265 0 25.265C13.455 33.965 22.6475 27.8 22.6475 27.8C16.5725 24.355 3.6875 7.8575 3.6875 7.8575C14.92 17.235 19.7675 19.6975 19.7675 19.6975C16.8525 17.3575 8.73 5.89 8.73 5.89C15.23 12.3375 28.15 21.3275 28.15 21.3275C31.855 11.3925 24.655 2.5 24.655 2.5Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_305_766"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwift);
export default __webpack_public_path__ + "static/media/swift.c45d0e486bc0882da9a19c46bcecc6b7.svg";
export { ForwardRef as ReactComponent };